import { PickSessionSchema } from "@redotech/redo-fulfillment-wms-common/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const healPickSessionSourcingDrift = {
  name: "healPickSessionSourcingDrift" as const,
  input: z.object({ pickSessionId: zExt.objectId() }),
  output: PickSessionSchema.nullable(),
};
